import moment from 'moment';

export default function makeDataLevel(d, pageIndex, pageSize, index) {
  return {
    rnum: pageIndex * pageSize + index + 1,
    areaNo: d.module.areaNo,
    areaNm: d.module.areaNm,
    modelNm: d.module.modelNm,
    h2s: d.h2s,
    h2: d.h2,
    statusCode: d.statusCode,
    status: 'blue',
    battery: d.battery,
    regDate: moment(d.rgstDt).format('YYYY-MM-DD HH:mm:ss'),
  };
}
